import styled from 'styled-components';
import { assignIfDefined, opaque } from 'styles/Utils';
import { WebFontBody2, WebFontBody1, WebFontCaption1 } from 'styles/Mixins';

const DEFAULT_INPUT_WIDTH = 328; // px

const InputSizeMixin = ({ size }: any) => {
  if (size === 'small') {
    return `
      ${WebFontBody2};
      height: 32px;
    `;
  }
  if (size === 'splash') {
    return `
      ${WebFontBody1};
      height: 48px;
    `;
  }
  // Default
  return `
      ${WebFontBody1};
      height: 40px;
    `;
};

export const Wrapper = styled.div<{ [props: string]: any }>`
  display: flex;
  flex-direction: column;
  ${assignIfDefined('margin')};
  width: ${({ stretch, width }) =>
    stretch ? '100%' : `${width || DEFAULT_INPUT_WIDTH}px`};
`;

export const ErrorMessage = styled.div`
  ${WebFontBody2};
  font-weight: bold;
  align-self: flex-end;
  margin-top: 4px;
  color: ${({ theme }) => theme.wishRed};
`;

export const InputWrapper = styled.div<{ hasRightSideElement?: boolean }>`
  width: 100%;
  ${({ hasRightSideElement }) => hasRightSideElement && 'position: relative'};
  display: flex;
`;

export const WishTextInput = styled.input<{ [props: string]: any }>`
  flex: ${({ flex }) => flex ?? '1'};
  border: 1px solid
    ${({ theme, isErrorShown, isWarningShown, isSuccessShown }) => {
      if (isErrorShown) {
        return theme.wishRed;
      } else if (isWarningShown) {
        return theme.wishDarkYellow;
      } else if (isSuccessShown) {
        return theme.SuccessGreen;
      } else {
        return theme.Grey5;
      }
    }};
  border-radius: 2px;
  ${InputSizeMixin}
  padding: ${({ padding }) => padding};
  text-align: ${({ textAlign }) => textAlign || 'left'};
  color: ${({ theme }) => theme.Grey1};
  background-color: ${({ theme, isWarningShown }) =>
    isWarningShown ? opaque(theme.wishLightYellow, 0.1) : theme.Grey7};
  width: 100% !important;
  ${assignIfDefined('height')};
  ${({ disabled }) =>
    disabled ? 'cursor: not-allowed; opacity: 0.5;' : 'cursor: auto;'};
  ${assignIfDefined('minHeight', 'min-height')};
  ${assignIfDefined('resize')};
  ${assignIfDefined('rows')};
  ${assignIfDefined('lineHeight', 'line-height')};
  ${assignIfDefined('boxSizing', 'box-sizing')};

  :focus {
    outline: 0;
    ${({ theme, isErrorShown, isSuccessShown }) =>
      isErrorShown || isSuccessShown
        ? ''
        : `border: 1px solid ${theme.primaryColor};`}
  }

  ::placeholder {
    color: ${({ theme }) => theme.Grey3};
  }
  ${({ userSelect }) =>
    userSelect &&
    `-o-user-select: ${userSelect}; -moz-user-select: ${userSelect}; -webkit-user-select: ${userSelect}; -ms-user-select: ${userSelect}; user-select: ${userSelect};`};
`;

export const WishTextRightSideWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
`;

export const RightSubText = styled.div`
  margin-top: 8px;
  text-align: right;
  color: ${({ theme }) => theme.Grey3};
  ${WebFontCaption1};
`;
